import { render } from "./AozoranoPlanetariumTalentList.vue?vue&type=template&id=5ca79cf8&scoped=true&ts=true&lang=pug"
import script from "./AozoranoPlanetariumTalentList.vue?vue&type=script&lang=ts"
export * from "./AozoranoPlanetariumTalentList.vue?vue&type=script&lang=ts"

import "./AozoranoPlanetariumTalentList.vue?vue&type=style&index=0&id=5ca79cf8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca79cf8"]])

export default __exports__